import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const backendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const brandingAssetUrl = (fileId) =>
  fileId ? `${backendUrl}/api/branding/files/${fileId}` : "";

export const useBranding = () =>
  useQuery({
    queryKey: ["platform-branding"],
    queryFn: async () => (await api.get("/branding")).data,
    staleTime: 5 * 60_000,
    retry: 1,
  });
